import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class ForceProvisioningError extends Component {
    // if can force provisioning also can force error
    state = {
        can_force_provisioning: false,
        error: false,
        showSnackBar: false,
        show_dialog: false,
        opInProgress: false
    };

    componentDidMount() {
        this.setState({
            can_force_provisioning: this.props.can_force_provisioning
        });
    }
    handleOk = () => {
        const { resource_id } = this.props;
        const body = {
            id: resource_id,
            data: {
                action: "force_provisioning_failed"
            },
            previousData: {
                password: null
            }
        };
        this.setState({ opInProgress: true });
        myRestClient("UPDATE", "installations", body).then(
            () => {
                this.setState({
                    showSnackBar: true,
                    error: false,
                    can_force_provisioning: false,
                    show_dialog: false,
                    opInProgress: false
                });
                window.location.reload();
            },
            () => {
                this.setState({
                    showSnackBar: true,
                    error: true,
                    show_dialog: false,
                    opInProgress: false
                });
            }
        );
    };

    handleCancel = () => {
        this.setState({ show_dialog: false });
    };

    handleClickOpen = () => {
        this.setState({ show_dialog: true });
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({
                        error: false,
                        showSnackBar: false
                    })
                }
            />
        );
    }

    renderSnackMessage() {
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.forcedErrorSucceeded`}
                />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.forceErrorFailed`}
                />
            </span>
        );
    }

    renderDialog() {
        return this.state.show_dialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.show_dialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText
                            resource_name={`resources.installations.actions.forceError`}
                        />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText
                        resource_name={`resources.installations.actions.force_error_warning`}
                    />
                </DialogContent>
                <DialogActions>
                    <div
                        align="center"
                        style={{
                            visibility: this.state.opInProgress
                                ? "visible"
                                : "hidden"
                        }}
                    >
                        {<CircularProgress />}
                    </div>
                    {!this.state.opInProgress && (
                        <div>
                            {" "}
                            <Button onClick={this.handleCancel} color="primary">
                                <TranslatedText
                                    resource_name={"ra.actions.cancel"}
                                />
                            </Button>
                            <Button
                                onClick={this.handleOk}
                                variant="contained"
                                color="secondary"
                            >
                                <TranslatedText
                                    resource_name={"ra.actions.ok"}
                                />
                            </Button>
                        </div>
                    )}
                </DialogActions>
            </Dialog>
        ) : null;
    }

    render() {
        return (
            <span>
                {this.state.can_force_provisioning ? (
                    <Button
                        color="primary"
                        target="_blank"
                        onClick={this.handleClickOpen}
                    >
                        <TranslatedText
                            resource_name={`resources.installations.actions.forceError`}
                        />
                    </Button>
                ) : null}
                {this.renderDialog()}
                {this.renderSnackBar()}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ForceProvisioningError.js